<script lang="ts" setup>
import type {
	// TCity,
	TTeacherData,
	TTeacherProfile,
} from "@/assets/js/globalTypes";

import api from "@/api";
import { openBookingModal } from "@/assets/js/scenario1";
// import { useSchoolStore } from "@/store/school";
import { $t } from "@/i18n";

type TRouteParams = {
	id: string;
};

definePage({
	name: "school.teacher-search.teacher-indivual-profile",
});

// const schoolStore = useSchoolStore();

const route = useRoute();
const isLoading = ref(false);
const teacherData = ref<TTeacherProfile | null>(null);

async function getTeacherData(id: number) {
	isLoading.value = true;

	try {
		const res = await api.getTeacher(id);
		teacherData.value = res.data.data;
	} catch (error) {
		console.error(error);
	} finally {
		isLoading.value = false;
	}
}

// function checkHasLocations(cities: TCity[]) {
// 	const locations = schoolStore.schoolData.locations;
// 	for (const el of locations) {
// 		if (cities.some((city) => city.cit_id === el.cit_id)) {
// 			return true;
// 		}
// 	}
// 	return false;
// 	// return locations && locations.length > 0;
// }

function handleClickBook() {
	openBookingModal(teacherData.value as unknown as TTeacherData);
}

watch(
	() => route.path,
	() => {
		const params = route.params as TRouteParams;
		if (params.id) {
			// Ensure id is parsed to number
			getTeacherData(Number(params.id));
		}
	},
	{
		immediate: true,
	},
);
</script>

<template>
	<div id="teacher-indivual-profile">
		<template v-if="isLoading && !teacherData">
			<div class="progress-spinner">
				<p-progress-spinner />
			</div>
		</template>
		<template v-else-if="!isLoading && !teacherData">
			{{ $t("app.base.no-results") }}
		</template>
		<template v-else>
			<individual-profile-top
				:teacher-data="teacherData"
				@click-book="handleClickBook"
			/>
			<individual-profile-bottom :teacher-data="teacherData" />
		</template>
	</div>
</template>

<style lang="scss" scoped>
#teacher-indivual-profile {
	padding: 20px 16px 56px;
	box-sizing: border-box;
	max-height: calc(100vh - $nav-top-bar - 1px);
	overflow-y: auto;

	.progress-spinner {
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 200px;
	}
}
</style>
